module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAPlJREFUeNpiXLdpGwOlINDXk4EJTUwRiNOgNEmABYmtBcTngZgNiOcCcQopBiG7KAdqCAiEAzEPuQZpIbFBhsSSa9BrNDl7cg3ajcR+CsTF5Bq0AGoACNxBYpNs0C8grkHyVhq5BoHAYiDeBGVPAGIzcg36C8RxQHwZiDmBeC8QeyDJGwCxLjEGgcBHIPaEhhMoGWwH4jlQr54B4ktAfAyIE6CW4TQIFmvmQHwQyk8G4plAzAzlWwLxfCDeQsggEHgHxG5A3A2NCGzgETEGwWKyDIg1oBHxHSksQZFST6xBMHAfGglcUENBmd2fFBdhAzeJjTWyAECAAQA0sS0NOxk6TwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconPhone.png
// module id = 820
// module chunks = 114276838955818